import gql from 'graphql-tag';
import { useQuery as defaultUseQuery } from '@apollo/react-hooks';

import { ApolloInjection } from '@zapier/design-system-revenue/src/types';
import { makeGqlMock } from '@zapier/design-system-revenue/src/mocks';

export const currentUserQuery = gql`
  query currentUserQuery {
    currentUserV2 {
      id
    }
  }
`;

type Props = {
  skip?: boolean;
} & ApolloInjection;

export const useCurrentUser = ({
  skip = false,
  useQuery = defaultUseQuery,
}: Props) => {
  const { data, error, loading } = useQuery(currentUserQuery, {
    skip,
  });

  return {
    currentUser: data?.currentUserV2,
    error: error ? 'Error loading current user information.' : undefined,
    isLoading: loading,
  };
};

export const useCurrentUserMock = makeGqlMock(
  {
    query: currentUserQuery,
  },
  {
    currentUserV2: {
      __typename: 'UserV2',
      id: '1',
    },
  }
);
